// Enums
export const HOW_IT_WORKS_ACTIONS = {
  SLIDE_LOADED: 'SLIDE_LOADED',
};

export function logHowItWorksInteraction({ action, slideLabel }) {
  const HOW_IT_WORKS_INTERACTION_EVENT_NAME = 'How It Works Interaction';

  const validationErrors = [];
  const interactionProperties = {
    action,
    slideLabel
  };

  // console.log('[log-how-it-works-interaction] logHowItWorksInteraction', interactionProperties);

  try {
    __validateAction();

    if (validationErrors.length) {
      console.error('[log-how-it-works-interaction] validationErrors', validationErrors);
    } else if (window.amplitude) {
      const eventBody = {
        ...interactionProperties,
        currentPage: {
          domain: window.location.host,
          path: window.location.pathname,
        }
      };

      // console.log('[log-how-it-works-interaction] LOGGING', JSON.stringify(eventBody));
      window.amplitude.getInstance().logEvent(HOW_IT_WORKS_INTERACTION_EVENT_NAME, eventBody);
    }
  } catch(error) { // Failure to log shouldn't break anything else. Catch and dump to console.
    console.error('[log-how-it-works-interaction] ERROR', error);
  }
  
  function __validateAction() {
    if (!action) {
      validationErrors.push({
        property: 'action',
        message: `action is required`,
      });
    } else if (!HOW_IT_WORKS_ACTIONS[interactionProperties.action]) {
      validationErrors.push({
        property: 'action',
        message: `Unknown action`,
      });
    } 
  }
}
